import { View } from './view'

export const Feedback = View
